import "/src/style/main.scss"
import AOS from 'aos';

document.addEventListener("DOMContentLoaded", function() {
    setTimeout(function () {
        AOS.init({
            offset: 100,
            duration: 600,
            delay: 100,
            once: true,
            disable: function() {
                let maxWidth = 800;
                return window.innerWidth < maxWidth;
            }
        });
    }, 100)
});

// Other
import "./functions";

// Modules

import SiteHeader from "./modules/site-header";
SiteHeader().init()

import SiteNav from "./modules/site-nav";
SiteNav().init()

import SiteNavMobile from "./modules/site-nav-mobile";
SiteNavMobile().init()

// import CustomSelect from "./modules/custom-select";
// CustomSelect().init()
//
import Cf7Form from "./modules/cf7-form";
Cf7Form().init()

import SliderServices from "./modules/slider-services";
SliderServices().init()

import PopupGallery from "./modules/popup-gallery";
PopupGallery().init()

import PopupGalleryVisitConfirmation from "./modules/popup-gallery-visit-confirmation";
PopupGalleryVisitConfirmation().init()

import Accordions from "./modules/accordions";
Accordions().init()

import NoAjaxLoadMore from "./modules/no-ajax-load-more";
NoAjaxLoadMore().init()

import NewsFilters from "./modules/news-filters";
NewsFilters().init()

import GoogleMap from "./modules/google-map";
GoogleMap().init()

// Templates

// Template parts

// Pages
